'use strict';
const angular = require('angular');

export class carouselMainComponent {
  constructor(SettingsService) {
    'ngInject';

    this.SettingsService = SettingsService;
  }

  $onInit() {

    let applyLocalConfig = () => {
      if (typeof this.heading !== 'undefined')
        this.vmHeading = this.heading;

      if (typeof this.subHeading !== 'undefined')
        this.vmSubHeading = this.subHeading;

      if (typeof this.slides !== 'undefined')
        this.vmSlides = this.slides;
    };

    if (this.settings) {

      this.SettingsService.getByName({name: this.settings}, config => {
        this.vmHeading = config.data.heading;
        this.vmSubHeading = config.data.subHeading;
        this.vmSlides = config.data.slides;

        applyLocalConfig();
      });

    } else {
      applyLocalConfig();
    }

  }
}

export default angular.module('conduuApp.carouselMain', [])
  .component('carouselMain', {
    template: require("./carouselMain.component.html"),
    bindings: {
      heading: '@',
      subHeading: '@',
      slides: '<',
      settings: '@'
    },
    controller: carouselMainComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/carousel-main/carouselMain.component.js